export default {"src":"/_next/static/media/manage_profile.a0444a6c.svg","height":105,"width":102,"blurWidth":0,"blurHeight":0};